<template>
<div>
    <head-nav :menuItems="menuItems" />
  <div class="seg-content general user">
      <template v-if="tab=='payment'">
        <div class="loading">(loading your payment)</div>
      </template>
      <template v-if="tab=='payment2'">
        <div style="grid-column: span 8">
          <iframe :src="paymentReady" class="payframe" style="height: 900px; width: 100%"></iframe>
        </div>
      </template>

    
    

    
  </div>

</div>
</template>
<script>
import api from './api';
import moment from 'moment';
import mainNav from './mainNav';
import Cookies from 'js-cookie';
export default {
  mixins: [mainNav],
  data: ()=>({
    tab: 'payment',
    package: null,
    paymentReady: null,
    detailsSaved: false,
    agreed: false,
    success: false,
    userProfile: {},
    groups: [],
    individualGroups: [],
//     buyGroup: {},
//     buyVideo: {},
//     cartItems: [],
  }),
  computed: {
    totalPrice() {
      return this.cartItems.map((a)=>a.price).reduce((a,b)=>a*1+b*1, 0);
    },
  },
  watch: {
    tab: {
      handler() {
        this.menuItems.forEach((el)=>el.active=el.args && el.args.tab==this.tab);
        this.success=false;
      }, immediate: true,
    },
  },
  methods: {
    async loadUserData() {
      if (window.appRoot.loggedIn) {
        this.userProfile=window.appRoot.loggedIn=(await api.get("User", window.appRoot.loggedIn.id)).item || {};
      }
    },
    async savePayment() {
      var result=await api.request("POST", "/pay/paypal", {});
      if (result.free) {
        await this.loadUserData();
        appNotifications.show("You are now subscribed", "success");
        this.$router.go(-1);
        return;
      }
      if (result.url) {
        this.paymentReady=result.url;
        this.tab="payment2";
      } else
        alert("Please try again later");
    },
  },
  created() {
    this.loadUserData();
//     this.updateCartItems();
  },
  mounted() {
    this.savePayment();
  },
}
</script>
